export default __webpack_public_path__ + "static/media/c001-E-commerce-6.388ee82e.jpg";